import useAuth from '@/hooks/useAuth';

// V2 Order Flow is restricted to tenant admins only.

const useOrderFlowV2Enabled = (): boolean => {
  // TODO: Temporarily disable OrderV2 — fallback to V1 for all users
  return false;
};

export default useOrderFlowV2Enabled;
